import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useMount, useUnmount } from 'react-use';

import { BoardlessConfigViewStore } from '~/classes/BoardlessConfigViewStore';
import { BoardlessConfigViewObserver } from '~/components/BordlessConfigViewObserver';
import { type DefaultBoardlessConfigViewsParams } from '~/constants/configViews';
import { resetConfigViewsAction, setSavedConfigurableViewsAction } from '~/store/configViews/actions';

export const GENERAL_PAGE_ID = 'general';

export type BoardlessConfigViewsParams = {
  pageId: string;
  defaultSort?: DefaultBoardlessConfigViewsParams['defaultSort'];
};
/**
 * This hook loads boardless page config view from local storage
 * If there is no config view saved for the page, it will create a default config view
 * It returns an element that can be used to observe the changes in the config view and save them to local storage
 */
export const useBoardlessConfigView = ({ defaultSort, pageId }: BoardlessConfigViewsParams) => {
  const dispatch = useDispatch();

  useMount(() => {
    const configViewsForPage = BoardlessConfigViewStore.getInstance().getSavedViewsForPage(pageId, defaultSort);
    dispatch(setSavedConfigurableViewsAction({ savedConfigurableViews: configViewsForPage }));
  });

  useUnmount(() => {
    dispatch(resetConfigViewsAction());
  });

  const BoardlessConfigObserver = useMemo(
    () => <BoardlessConfigViewObserver pageId={pageId} defaultSort={defaultSort} />,
    [pageId, defaultSort],
  );

  return {
    BoardlessConfigObserver,
  };
};
